export default "__VITE_ASSET__bOmJ8Smr__"